import styled from 'styled-components';
import { Popup } from '~/components/ui/Popup';

const StyledInputArrowContainer = styled.div`
	display: flex;
	gap: 10px;
	flex-direction: row;
	justify-content: space-between;

	& > * {
		border-radius: 3px;
	}
`;

const StyledTextContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
	min-height: 18px;

	span {
		min-width: 20px;
		font-family: 'GT Walsheim Pro';
		font-size: 12px;
		color: #ffffff;
		text-align: right;
		white-space: nowrap;
	}

	& > span {
		width: 42px;
		min-width: 42px;
		flex: 0 0 42px;
	}
`;

const StyledCopyButton = styled.button`
	box-sizing: border-box;
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	min-width: 18px;
	max-width: 18px;
	height: 18px;
	min-height: 18px;
	max-height: 18px;
	padding: 0;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 3px;
	background-color: rgba(255, 255, 255, 0.06);
	cursor: pointer;
	flex: 0 0 18px;

	transition:
		background-color 0.2s ease,
		color 0.2s ease;

	img {
		display: block;
		width: 10px;
		height: 10px;
		flex-shrink: 0;
		user-select: none;
		pointer-events: none;
		opacity: 0.8;
	}

	&:hover {
		background-color: rgba(255, 255, 255, 0.16);
		color: #ffffff;
	}
`;

const StyledTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	min-width: 0;

	span {
		min-width: 0;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
	}
`;

const StyledCopyContainer = styled.div<{ $visible: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	width: 18px;
	min-width: 18px;
	max-width: 18px;
	height: 18px;
	flex: 0 0 18px;
	pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};

	${StyledCopyButton} {
		opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	}
`;

const StyledPopup = styled(Popup)`
	position: absolute;
	left: 50%;
	bottom: calc(100% + 8px);
	transform: translateX(-50%);
	z-index: 2;
	width: max-content;
`;

const StyledSelectorContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledInput = styled.input`
	display: block;
	width: 60px;
	height: 20px;
	padding: 4px;
	border-width: 0;
	outline: none;

	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	text-align: center;
`;

const StyledArrow = styled.i<{ $direction: 'left' | 'right' }>`
	display: block;
	position: relative;
	width: 20px;
	height: 20px;
	background-color: rgba(50, 50, 50, 1);
	cursor: pointer;

	&::after {
		content: '';
		position: absolute;
		inset: 6px;
		border: solid white;
		border-width: 0 3px 3px 0;
		transform: rotate(
			${({ $direction }) => ($direction === 'left' ? '135deg' : '-45deg')}
		);
	}
`;

export {
	StyledArrow,
	StyledCopyButton,
	StyledCopyContainer,
	StyledInput,
	StyledInputArrowContainer,
	StyledPopup,
	StyledSelectorContainer,
	StyledTextContainer,
	StyledTitleContainer,
};
